module.exports = __webpack_public_path__ + "static/img/icon_zylx04.4aae89dc.png";